<template>
  <div class="live-commentary-setting">
    <div class="top">
      <div class="title">
        Setting
      </div>
      <div
        class="close"
        @click="handleClose()"
      >
        <svg-icon icon-class="icon-close" />
      </div>
    </div>
    <div class="main">
      <div class="live-commentary-setting-item">
        <div class="left">
          <svg-icon icon-class="icon-signal" />
          <p>Automatic update of data</p>
        </div>
        <div class="right">
          <VSwitch
            :value="commentarySubStatus"
            :change-now="false"
            @switch="handleUpdateSwitch"
          />
        </div>
      </div>
      <div class="live-commentary-setting-item">
        <div class="left">
          <svg-icon icon-class="icon-voice-up" />
          <p>Animation and sounds</p>
        </div>
        <div class="right">
          <VSwitch
            :value="commentaryAnimStatus"
            :change-now="false"
            @switch="handleAnimeSwitch"
          />
        </div>
      </div>
      <div class="live-commentary-setting-item">
        <div class="left">
          <svg-icon icon-class="icon-bottom-bar" />
          <p>Dynamic bottom bar</p>
        </div>
        <div class="right">
          <VSwitch
            :value="commentaryBotStatus"
            :change-now="false"
            @switch="handleBottomBarSwitch"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import toast from 'fe-vui/toast'
import VSwitch from 'wap/components/VSwitch'
import 'base/icons/svg/signal.svg'
import 'base/icons/svg/voice-up.svg'
import 'base/icons/svg/close.svg'
import 'base/icons/svg/bottom-bar.svg'
export default {
  name: 'CommentarySetting',
  components: {
    VSwitch
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { commentarySubStatus, commentaryAnimStatus, commentaryBotStatus } = storeToRefs(matchDetailStore)

    const { subCommentary } = matchDetailStore

    return {
      commentarySubStatus,
      commentaryAnimStatus,
      commentaryBotStatus,
      subCommentary
    }
  },
  methods: {
    handleUpdateSwitch() {
      const status = !this.commentarySubStatus
      useMatchDetailStore().updateCommentarySubStatus(status)
      this.subCommentary({ isSub: status })
      const text = status ? 'Automatic update opened successfully.' : ' Automatic update closed successfully.'
      toast(text)
      localStorage.setItem('live_commentary_update', status)
    },
    handleAnimeSwitch() {
      const status = !this.commentaryAnimStatus
      useMatchDetailStore().updateCommentaryAnimStatus(status)
      const text = status ? 'Animations and sounds opened successfully.' : 'Animations and sounds closed successfully.'
      toast(text)
      localStorage.setItem('live_commentary_anime', status)
    },
    // 底部浮窗 开关
    handleBottomBarSwitch() {
      const status = !this.commentaryBotStatus
      useMatchDetailStore().updateCommentaryBotStatus(status)
      const text = status ? 'Dynamic bottom bar opened successfully.' : 'Dynamic bottom bar closed successfully.'
      toast(text)
      localStorage.setItem('live_commentary_bottom', status)
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-setting {
  position: fixed;
  z-index: 15;
  bottom: 60px;
  width: 100%;
  max-width: 750px;
  border-bottom: 1px solid @normal;
  background: @major;
  color: @white;
  font-size: 14px;

  .top {
    display: flex;
    width: 330/360 * 100%;
    height: 38px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid @normal;
    margin: 0 auto;

    .close {
      display: flex;
      width: 30px;
      height: 30px;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .main {
    width: 330/360 * 100%;
    margin: 0 auto;
  }

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0 10px;

    .svg-icon {
      margin-right: 7px;
    }

    .left {
      display: flex;
    }
  }

  .v-switch {
    border-color: @primary;

    &::after {
      background-color: @primary;
    }

    &.v-switch-on::after {
      background-color: @major;
    }
  }
}

</style>
